<template>
  <div :key="$route.fullPath" :class="['uk-grid-medium', { 'uk-grid': true }]" uk-grid>
    <div class="uk-width-5-5">
      <div class="d-flex">
        <Breadcrumb :items="breadcrumbItems" />
      </div>

      <template v-if="errorMessages.length > 0">
        <div class="card">
          <div v-for="(error, index) in errorMessages" v-if="errorMessages" :key="index" class="uk-alert-danger" uk-alert>
            <a class="uk-alert-close" uk-close></a>
            <p style="color:red;">
              <i class="uil-exclamation-triangle"></i> {{ error }}
            </p>
          </div>
        </div>
      </template>

      <template v-if="successMessage">
        <div class="card">
          <div class="uk-alert-success" uk-alert>
            <a class="uk-alert-close" uk-close></a>
            <p style="color:green;">
              <i class="uil-exclamation-triangle"></i> {{ $t('general.update_success') }}
            </p>
          </div>
        </div>
      </template>

      <div class="section-header mb-lg-2 border-0 uk-flex-middle">
        <div class="section-header-left">
          <h2 class="uk-heading-line text-left">
            <span>{{ isEditMode ? $t('general.catalog_education_update') : $t('general.add_catalog_education') }}</span>
          </h2>
        </div>
      </div>

      <div class="card">
        <ul class="uk-child-width-expand uk-tab stepper-buttons"
          uk-switcher="connect: #course-edit-tab ; animation: uk-animation-slide-left-medium, uk-animation-slide-right-medium">
          <li class="uk-active">
            <a aria-expanded="true" class="p-4" href="#"><i class="icon-feather-flag"></i>
              <b>{{ this.$t('messages.login') }}</b></a>
          </li>
          <li class="">
            <a aria-expanded="false" class="p-4" href="#"><i class="uil-book-open"></i>
              <b>{{ $t('general.content') }}</b></a>
          </li>
          <li>
            <a aria-expanded="false" class="p-4" href="#"><i class="uil-cog"></i>
              <b>{{ $t('general.features') }}</b></a>
          </li>
          <li>
            <a aria-expanded="false" class="p-4" href="#"><i class="uil-invoice"></i>
              <b>{{ $t('general.overview') }}</b></a>
          </li>
        </ul>

        <div class="card-body">
          <default-loading v-if="catalog_loading"></default-loading>
          <ul v-show="!catalog_loading" id="course-edit-tab" class="uk-switcher uk-margin"
            style="touch-action: pan-y pinch-zoom;">
            <!--tab 1: özellikler-->
            <li class="uk-active" style="">
              <div class="row">
                <div class="col-xl-9 m-auto">
                  <div class="form-group row mb-3">
                    <label class="col-md-3 col-form-label" for="course_title">{{ $t('training.training_title') }}<span
                        class="required">*</span></label>
                    <div class="col-md-9">
                      <input id="course_title" v-model="currentForm.title" class="form-control" name="title" type="text">
                    </div>
                  </div>
                  <div class="form-group row mb-3">
                    <label class="col-md-3 col-form-label" for="course_code">{{ $t('training.education_code') }}<span
                        class="required">*</span></label>
                    <div v-if="!isEditMode" class="col-md-3">
                      <toggle-button v-model="currentForm.code_is_auto"
                        :labels="{ unchecked: $t('general.manually'), checked: $t('general.automatic') }" :value="true"
                        :width="100" color="#ae71ff" />
                    </div>
                    <div v-if="!currentForm.code_is_auto || isEditMode" :class="isEditMode ? 'col-md-9' : 'col-md-6'">
                      <input id="course_code" v-model="currentForm.code" class="form-control" name="course_code"
                        placeholder="" required="" type="text">
                    </div>
                  </div>
                  <div class="form-group row mb-3">
                    <label class="col-md-3 col-form-label" for="description">{{ $t('general.description') }}<span
                        class="required">*</span></label>
                    <div class="col-md-9">
                      <textarea id="description" v-model="currentForm.description" class="form-control"
                        name="description"></textarea>
                    </div>
                  </div>
                  <div class="form-group row mb-3">
                    <label class="col-md-3 col-form-label" for="category">{{ $t('general.category') }} <span
                        class="required">*</span></label>
                    <div class="col-md-7">
                      <MultipleSelectInput v-model="selectedCategory" :allow-empty="true" :show-labels="false"
                        :values="educationTypes" label="name" track-by="id" />
                    </div>
                    <div class="col-md-2">
                      <a class="btn btn-sm btn-secondary btn-icon-label uk-first-column" @click="openCategoryEditModal">
                        <span class="btn-inner--icon"><i class="uil-edit"></i></span>
                        <span class="btn-inner--text">{{ $t('general.edit') }}</span>
                      </a>
                    </div>
                  </div>

                  <div class="form-group row mb-3">
                    <label class="col-md-3 col-form-label">{{
                      $t('general.training_types')
                    }} <span class="required">*</span></label>
                    <div class="col-md-9">
                      <MultipleSelectInput v-model="selectedTrainingKind" :allow-empty="true" :show-labels="false"
                        :values="formattedTrainingKind" label="name" track-by="id" />
                    </div>
                  </div>

                  <div class="form-group row mb-3">
                    <label class="col-md-3 col-form-label">{{ $t('general.cover_image') }}<span
                        class="required">*</span></label>
                    <div class="col-md-9">
                      <div uk-alert>
                        <a class="uk-alert-close" uk-close></a>
                        <h5><i class="uil-comment-info-alt"></i> {{ $t('general.information') }}</h5>
                        <p v-html="$t('general.catalog_cover_image_info', {
                          formats: '<b>.jpg, .png, .gif</b>',
                          dimensions: '<b>521x288</b>'
                        })"></p>
                      </div>
                      <ImageDragDropUpload
                        :existing-image-url="isEditMode && currentForm.cover_image_link ? currentForm.cover_image_link : null"
                        @file-selected="handleImageSelected" />
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="hashtags">{{ $t('general.category_tags') }}</label>
                    <MultipleSelectInput v-model="selectedHashtags" :allow-empty="true" :multiple="true"
                      :searchable="true" :show-labels="false" :taggable="true" :values="hashtagOptions" label="name"
                      track-by="id" @addTag="handleHashtagTag" />
                  </div>
                </div>
              </div>
              <div class="uk-card-footer float-right pb-0 pr-0">
                <button class="uk-button uk-button-primary small" type="submit" @click="validateAndSwitch(1)"><i
                    class="icon-feather-arrow-right"></i>{{ this.$t('general.save_and_continue') }}
                </button>
              </div>
            </li>
            <!--tab 2: icerik olustur-->
            <li class="" style="">

              <ContentAreaAddEditModal ref="formContent" :catalog-section-data="item?.training_section"
                :is-edit-mode="isEditMode" @getData="getData($event)" @useScormScore="useScormScore($event)" />

              <div class="uk-card-footer float-right pb-0 pr-0">
                <button class="uk-button uk-button-outline small mr-2" type="submit" @click="switcherChange(0)"><i
                    class="icon-feather-arrow-left"></i> {{ $t('general.previous') }}
                </button>
                <button class="uk-button uk-button-primary small" type="submit" @click="validateAndSwitch(2)"><i
                    class="icon-feather-arrow-right"></i> {{ this.$t('general.save_and_continue') }}
                </button>
              </div>
            </li>
            <!--tab 3: özellikler-->
            <li>
              <div class="container">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group row mb-2">
                      <label class="col-md-3 col-form-label">{{ $t('general.price') }}</label>
                      <div class="col-md-3">
                        <input v-model="currentForm.price" class="form-control" type="number" />
                      </div>
                      <div class="col-md-3">
                        <MultipleSelectInput v-model="selectedCurrency" :allow-empty="true" :show-labels="false"
                          :values="currencyOptions" label="name" track-by="code" />
                      </div>
                    </div>
                    <div class="form-group row mb-2">
                      <label class="col-md-3 col-form-label">{{ $t('general.discount_message') }}
                        <i aria-expanded="false" class="uil-info-circle" title="" uk-tooltip="title: "></i></label>
                      <div class="col-md-6">
                        <textarea id="sale" v-model="currentForm.discount_codes" class="form-control"
                          name="sale"></textarea>
                      </div>
                    </div>
                    <div class="form-group row mb-2">
                      <div class="col-md-3 col-form-label">
                        <label for="sale_ratio">{{ $t('general.discount_rate') }} (%)</label>
                      </div>
                      <div class="col-md-6">
                        <input id="sale_ratio" v-model="currentForm.discount_percent" class="form-control" name="title"
                          placeholder="" required="" type="number">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="uk-card-footer float-right pb-0 pr-0">
                  <button class="uk-button uk-button-outline small mr-2" type="submit" @click="switcherChange(1)"><i
                      class="icon-feather-arrow-left"></i>{{ $t('general.previous') }}
                  </button>
                  <button class="uk-button uk-button-primary small" type="submit" @click="validateAndSwitch(3)"><i
                      class="icon-feather-arrow-right"></i> {{ this.$t('general.save_and_continue') }}
                  </button>
                </div>
              </div>
            </li>
            <!--tab 4: özellikler-->
            <li>
              <div class="row">
                <div class="col-12 my-lg-5">
                  <div class="text-center">
                    <h2 class="mt-0"><i class="icon-feather-check-circle text-success"></i></h2>
                    <h3 class="mt-0">{{ $t('general.content_is_ready') }} !</h3>

                    <div class="col-md-6 offset-md-3">
                      <table class="uk-table uk-table-divider result-table">
                        <tbody>
                          <tr>
                            <td class="text-right">{{ $t('general.cover_image') }}:</td>
                            <td class="text-left">
                              <img id="summaryImage"
                                :src="isEditMode && currentForm.cover_image_link ? currentForm.cover_image_link : '@/assets/images/no-photo.png'"
                                alt="" class="rounded img-fluid">
                            </td>
                          </tr>
                          <tr>
                            <td class="text-right">{{ this.$t('collectionDetail.content_name') }}:</td>
                            <td class="text-left"><b>{{ currentForm.title }}</b></td>
                          </tr>
                          <tr>
                            <td class="text-right">{{ $t('general.category_tags') }}:</td>
                            <td class="text-left"><b>{{ hashtagContent }}</b></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="uk-card-footer float-right pb-0 pr-0">
                <button class="uk-button uk-button-outline small mr-2" type="submit" @click="switcherChange(2)"><i
                    class="icon-feather-arrow-left"></i> {{ $t('general.previous') }}
                </button>
                <button class="uk-button uk-button-primary small" type="submit" @click="saveForm"><i
                    class="icon-feather-arrow-right"></i> {{ $t('general.save') }}
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <CategoryEditModal ref="categoryEditModalRef" :categories="educationTypes" @add-category="handleAddCategory"
      @save-category="handleSaveCategory" @delete-category="handleDeleteCategory" />
  </div>
</template>

<script>
import store from '@/core/services'
import ContentAreaAddEditModal from "./components/ContentAreaAddEditModal.vue";
import DefaultLoading from "@/view/components/loading/DefaultLoading.vue";
import Breadcrumb from "@/view/components/breadCrumb/Breadcrumb.vue";
import CategoryEditModal from "./components/CategoryEditModal.vue";
import ImageDragDropUpload from "@/view/components/input/ImageDragDropUpload.vue";
import MultipleSelectInput from "@/assets/components/inputs/MultipleSelectInput";

import { GET_ITEMS as GET_CATEGORIES, ITEMS as CATEGORIES } from "@/core/services/store/REST.module";

import training_kind_module, {
  BASE_URL as TRAINING_KIND_URL,
  GET_ITEMS as GET_TRAINING_KINDS,
  MODULE_NAME as MODULE_TRAINING_KIND,
  ERROR,
  ITEMS as TRAINING_KINDS
} from "@/core/services/store/training_kind.module";

import hashtag_module, {
  BASE_URL as HASHTAG_URL,
  GET_ITEMS as GET_HASHTAGS,
  MODULE_NAME as MODULE_HASHTAG,
  ITEMS as HASHTAGS
} from "@/core/services/store/hashtag.module";

import training_module, {
  BASE_URL as TRAINING_BASE_URL,
  MODULE_NAME as TRAINING_MODULE,
  CREATE_ITEM as CREATE_TRAINING,
  UPDATE_ITEM as UPDATE_TRAINING,
  GET_ITEM as GET_TRAINING,
  ITEM as TRAINING,
  ERROR as TRAINING_ERROR,
  LOADING as TRAINING_LOADING
} from "@/core/services/store/training.module";

const _TRAINING_KIND_MODULE = MODULE_TRAINING_KIND;
const _HASHTAG_MODULE = MODULE_HASHTAG;
const _TRAINING_MODULE = TRAINING_MODULE;
import axios from "axios";

export default {
  name: "CatalogContentAddUpdate",
  components: {
    DefaultLoading,
    ContentAreaAddEditModal,
    Breadcrumb,
    CategoryEditModal,
    ImageDragDropUpload,
    MultipleSelectInput
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule)
      }
    }

    registerStoreModule(_TRAINING_KIND_MODULE, training_kind_module)
    registerStoreModule(_HASHTAG_MODULE, hashtag_module)
    registerStoreModule(_TRAINING_MODULE, training_module)
  },
  data() {
    return {
      currencies: [],
      company_id: '',
      hashtagOptions: [],
      form: {
        title: '',
        code_is_auto: true,
        code: '',
        description: '',
        category_id: null,
        training_kind_id: null,
        media: null,
        price: 0.00,
        discount_codes: '',
        discount_percent: '',
        hashtags: [],
        contents: null,
        currency: "TRY",
        cover_image_link: null
      },
      trainingCategoryUrl: 'api/training-type',
      educationTypes: [],
      errorMessages: [],
      hashtagContent: "",
      successMessage: false,
      use_scorm_score: false,
      isDataLoaded: false
    }
  },
  computed: {
    isEditMode() {
      return !!this.$route.params.id;
    },
    breadcrumbItems() {
      return [
        {
          name: this.$t('general.training'),
          route: { name: 'company.education.catalog.list' }
        },
        {
          name: this.isEditMode
            ? this.$t('general.catalog_education_update')
            : this.$t('general.add_catalog_education')
        }
      ];
    },
    item: {
      get() {
        return store.getters[_TRAINING_MODULE + '/' + TRAINING]
      },
      set(value) {
      }
    },
    training_kinds: {
      get() {
        return store.getters[_TRAINING_KIND_MODULE + '/' + TRAINING_KINDS]
      },
      set(value) {
      }
    },
    catalog_loading: {
      get() {
        return store.getters[_TRAINING_MODULE + '/' + TRAINING_LOADING]
      },
      set(value) {
      }
    },
    hashtags: {
      get() {
        return store.getters[_HASHTAG_MODULE + '/' + HASHTAGS]
      },
      set(value) {
      }
    },
    formattedItem() {
      if (!this.item || Object.keys(this.item).length === 0) return {};
      let itemCopy = Object.assign({}, this.item);
      itemCopy['category_id'] = itemCopy.training_type_id;
      return itemCopy;
    },
    currentForm() {
      return this.form;
    },
    formattedTrainingKind() {
      let results = [];
      if (this.training_kinds === null || !("data" in this.training_kinds)) return [];
      this.training_kinds.data.forEach(item => {
        results.push({
          id: item.id,
          value: item.id,
          name: item.name
        });
      });
      return results;
    },
    currencyOptions() {
      if (!Array.isArray(this.currencies)) return [];
      return this.currencies.map(currency => ({
        code: currency.code,
        name: currency.symbol ? `${currency.name} (${currency.symbol})` : currency.name
      }));
    },
    selectedCategory: {
      get() {
        const id = this.form.category_id;
        return this.educationTypes?.find(item => item.id === id) || null;
      },
      set(value) {
        this.form.category_id = value ? value.id : null;
      }
    },
    selectedTrainingKind: {
      get() {
        const id = this.form.training_kind_id;
        return this.formattedTrainingKind?.find(item => item.id === id) || null;
      },
      set(value) {
        this.form.training_kind_id = value ? value.id : null;
      }
    },
    selectedCurrency: {
      get() {
        const code = this.form.currency;
        return this.currencyOptions?.find(item => item.code === code) || null;
      },
      set(value) {
        this.form.currency = value ? value.code : "TRY";
      }
    },
    selectedHashtags: {
      get() {
        const options = this.hashtagOptions || [];
        const selected = this.form.hashtags || [];

        const map = new Map(options.map(i => [i.id, i]));

        return selected
          .map(id => {
            const realId = typeof id === 'object' ? id.id : id;
            return map.get(realId) || null;
          })
          .filter(Boolean);
      },

      set(values) {
        this.form.hashtags = (values || [])
          .map(i => i.id)
          .filter(Boolean);
      }
    },
    formattedHashTag() {
      let results = [];
      if (this.hashtags === null || !("data" in this.hashtags)) return [];
      this.hashtags.data.forEach(item => {
        results.push({
          id: item.id,
          value: item.id,
          name: item.name
        });
      });
      return results;
    },
    errors: {
      get() {
        return store.getters[_TRAINING_MODULE + '/' + TRAINING_ERROR]
      },
      set(value) {
      }
    },
  },
  methods: {
    resetForm() {
      this.isDataLoaded = false;
      this.form = {
        title: '',
        code_is_auto: true,
        code: '',
        description: '',
        category_id: null,
        training_kind_id: null,
        media: null,
        price: 0.00,
        discount_codes: '',
        discount_percent: '',
        hashtags: [],
        contents: null,
        currency: "TRY",
        cover_image_link: null
      };
    },
    fetchTraining(id) {
      this.resetForm();

      store.dispatch(_TRAINING_MODULE + '/' + GET_TRAINING, {
        url: TRAINING_BASE_URL + '/' + id,
      }).then((res) => {

        this.loadFormData();

        // 🔥 CRITICAL FIX: normalize hashtags immediately
        this.form.hashtags = (this.form.hashtags || []).map(h =>
          typeof h === 'object' ? h.id : h
        );

      });
    },
    loadFormData() {
      if (!this.formattedItem) return;

      this.form.title = this.formattedItem.name || '';
      this.form.code = this.formattedItem.code || '';
      this.form.description = this.formattedItem.description || '';
      this.form.category_id = this.formattedItem.category_id || null;
      this.form.training_kind_id = this.formattedItem.training_kind_id || null;
      this.form.price = this.formattedItem.price || 0;
      this.form.discount_codes = this.formattedItem.discount_codes || '';
      this.form.discount_percent = this.formattedItem.discount_percent || '';
      this.form.currency = this.formattedItem.currency || "TRY";
      this.form.cover_image_link = this.formattedItem.cover_image_link || null;
      this.form.hashtags = (this.formattedItem.hashtag || []).map(h => {
        return typeof h === 'object' ? h.id : h;
      });

      this.isDataLoaded = true;
    },

    syncHashtagOptions(items) {
      if (!Array.isArray(items)) return;
      const existingIds = new Set(this.hashtagOptions.map(item => item.id));
      items.forEach((item) => {
        if (!existingIds.has(item.id)) {
          this.hashtagOptions.push(item);
        }
      });
    },
    handleHashtagTag(tag) {
      if (!tag) return;
      const newTag = {
        id: tag.id ?? tag.name ?? tag,
        name: tag.name ?? tag.id ?? String(tag),
      };

      if (!this.hashtagOptions.find(item => item.id === newTag.id)) {
        this.hashtagOptions.push(newTag);
      }

      if (!this.form.hashtags.includes(newTag.id)) {
        this.form.hashtags = [...this.form.hashtags, newTag.id];
      }
    },
    openCategoryEditModal() {
      this.$refs.categoryEditModalRef?.show();
    },
    getCurrency() {
      axios.get('api/currencies').then((result) => {
        this.currencies = result.data;
      })
    },
    handleDeleteCategory({ element, index }) {
      axios.delete(`api/training-type/` + element.id + '').then((result) => {
        if (result) {
          this.educationTypes.splice(index, 1)
        }
      })
    },
    handleSaveCategory({ element, index }) {
      axios.put(`api/training-type/` + element.id + '',
        { "name": element.name }).then((result) => {
        })
    },
    handleAddCategory(categoryName) {
      axios.post(`api/training-type/`,
        { "name": categoryName }).then((result) => {
          if (result) {
            this.getTrainingTypes();
          }
        })
    },
    resetMessages() {
      this.successMessage = null;
      this.errorMessages = [];
    },
    showFieldsFailedError(index, message) {
      this.errorMessages.push(message);
      this.scrollToTop();
      this.switcherChange(index);
      return false;
    },
    validateAndSwitch(index) {
      if (this.isValidFields(index - 1)) this.switcherChange(index);
    },
    switcherChange(index) {
      UIkit.switcher($('.uk-child-width-expand')[0]).show(index);
      $("html, body").animate({ scrollTop: 0 }, "slow");
    },
    isValidFields(fields) {
      let form = this.currentForm;
      this.resetMessages();

      if (fields === 0 || fields === 'ALL') {
        if (form.title.length <= 2) {
          return this.showFieldsFailedError(
            0,
            this.$t("validation.min_character_length")
              .replace(":attribute", this.$t('training.training_title'))
              .replace(":min", this.$t('3'))
          );
        }

        if (!this.isEditMode && form.code_is_auto) {
          this.form.code = this.makeCode(10);
        } else {
          if (form.code.length === 0) {
            return this.showFieldsFailedError(
              0,
              this.$t("validation.required_field")
                .replace(":NAME", this.$t('training.education_code'))
            );
          }
        }

        if (form.description.length <= 2) {
          return this.showFieldsFailedError(
            0,
            this.$t("validation.min_character_length")
              .replace(":attribute", this.$t('general.description'))
              .replace(":min", this.$t('3'))
          );
        }

        if (!form.category_id || form.category_id.length === 0) {
          return this.showFieldsFailedError(
            0,
            this.$t("validation.required_field")
              .replace(":NAME", this.$t('general.category'))
          );
        }

        if (!form.training_kind_id || form.training_kind_id.length === 0) {
          return this.showFieldsFailedError(
            0,
            this.$t("validation.required_field")
              .replace(":NAME", this.$t('general.training_types'))
          );
        }

        if (!this.isEditMode && !this.form.media) {
          return this.showFieldsFailedError(
            0,
            this.$t("validation.required_field")
              .replace(":NAME", this.$t('general.cover_image'))
          );
        }

        if (this.isEditMode && !this.item.media && !this.formattedItem.cover_image_link) {
          return this.showFieldsFailedError(
            0,
            this.$t("validation.required_field")
              .replace(":NAME", this.$t('general.cover_image'))
          );
        }
      }

      if (fields === 1 || fields === 'ALL') {
        let contents = this.isEditMode
          ? (this.$refs.formContent?.$data?.form?.contents || this.form.contents)
          : this.form.contents;

        if (!contents || contents.length === 0) {
          return this.showFieldsFailedError(1, this.$t("general.add_content_and_education"));
        }

        for (let contentItem of contents) {
          if (!contentItem.educations || contentItem.educations.length === 0) {
            return this.showFieldsFailedError(1, this.$t("general.create_edu_content"));
          }
        }
      }

      return true
    },
    handleImageSelected(file) {
      if (this.isEditMode) {
        this.item.media = file;
      } else {
        this.form.media = file;
      }
      $('#summaryImage').attr('src', URL.createObjectURL(file));
    },
    getData(data) {
      this.form.contents = data;
    },
    useScormScore(data) {
      this.use_scorm_score = data;
    },
    makeCode(length) {
      let result = '';
      let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },
    saveForm() {
      if (!this.isValidFields("ALL")) return false;

      let form = this.currentForm;
      let formData = new FormData();

      formData.append('name', form.title);
      formData.append('code', form.code);
      formData.append('description', form.description);
      formData.append('category_id', form.category_id);
      formData.append('training_kind_id', form.training_kind_id);
      formData.append('price', form.price);

      if (this.isEditMode && this.item.media) {
        formData.append('media', this.item.media);
      } else if (!this.isEditMode && this.form.media) {
        formData.append('media', this.form.media);
      }

      if (!this.isEditMode) {
        formData.append('hashtags', this.form.hashtags);
      } else {
        formData.append('hashtags', this.hashtagContent);
      }

      formData.append('discount_codes', form.discount_codes || '');
      formData.append('discount_percent', form.discount_percent || '');
      formData.append('currency', form.currency);

      let contents = this.isEditMode
        ? (this.$refs.formContent?.$data?.form?.contents || this.form.contents)
        : this.form.contents;

      const submitContents = this.getSubmitContents(contents);

      this.createFormDataForList(formData, 'contents', submitContents);

      contents?.forEach((item, index) => {
        if (item.educations?.length > 0) {
          item.educations.forEach((edu, eduindex) => {
            if (edu.media instanceof File || edu.media instanceof Blob) {
              formData.append('contents[' + index + ']' + '[educations][' + eduindex + '][media]', edu.media);
            }
          });
        }
      });

      if (this.isEditMode) {
        // Update
        store.dispatch(_TRAINING_MODULE + '/' + UPDATE_TRAINING, {
          url: TRAINING_BASE_URL + "/" + this.$route.params.id,
          contents: formData
        }).then((res) => {
          if (res) {
            this.scrollToTop();
            this.successMessage = true;
            setTimeout(() => {
              this.$router.push({ name: 'company.education.catalog.list' })
            }, 1000);
          } else {
            this.errorMessages = [];
            this.errorMessages.push(this.errors);
            this.scrollToTop();
          }
        });
      } else {
        // Create
        store.dispatch(_TRAINING_MODULE + '/' + CREATE_TRAINING, {
          url: TRAINING_BASE_URL,
          contents: formData
        }).then((res) => {
          if (res) {
            this.scrollToTop();
            this.successMessage = true;
            this.$router.push({ name: 'company.education.catalog.list' })
          } else {
            this.errorMessages = [];
            this.errorMessages.push(this.errors);
            this.scrollToTop();
          }
        });
      }
    },
    getSubmitContents(contents) {
      if (this.isEditMode) {
        return this.normalizeContentsForUpdate(contents);
      }
      return this.normalizeContentsForCreate(contents);
    },
    normalizeContentsForCreate(contents) {
      if (!Array.isArray(contents)) return [];

      const omitUndefined = (obj) => {
        const result = {};
        Object.keys(obj).forEach((key) => {
          if (obj[key] !== undefined && obj[key] !== null) {
            result[key] = obj[key];
          }
        });
        return result;
      };

      return contents.map((contentItem) => {
        const educations = Array.isArray(contentItem.educations) ? contentItem.educations : [];
        const normalizedEducations = educations.map((education) => {
          const normalized = { ...education };

          // content_type_id create'de obje olarak bekleniyor olabilir
          if (normalized.content_type_id && typeof normalized.content_type_id !== 'object') {
            normalized.content_type_id = { id: normalized.content_type_id };
          }

          if (!normalized.training_file_type_id && normalized.content_type_id?.id) {
            normalized.training_file_type_id = normalized.content_type_id.id;
          }

          if (normalized.media instanceof File || normalized.media instanceof Blob) {
            delete normalized.media;
          }

          return omitUndefined(normalized);
        });

        return omitUndefined({
          ...contentItem,
          educations: normalizedEducations,
        });
      });
    },
    normalizeContentsForUpdate(contents) {
      return this.normalizeContentsForSubmit(contents);
    },
    normalizeContentsForSubmit(contents) {
      if (!Array.isArray(contents)) return [];

      const normalizeId = (value) => {
        if (value && typeof value === 'object' && Object.prototype.hasOwnProperty.call(value, 'id')) {
          return value.id;
        }
        return value;
      };

      const omitUndefined = (obj) => {
        const result = {};
        Object.keys(obj).forEach((key) => {
          if (obj[key] !== undefined && obj[key] !== null) {
            result[key] = obj[key];
          }
        });
        return result;
      };

      return contents.map((contentItem) => {
        const educations = Array.isArray(contentItem.educations) ? contentItem.educations : [];
        const normalizedEducations = educations.map((education) => {
          const normalized = { ...education };

          normalized.content_type_id = normalizeId(normalized.content_type_id);
          normalized.training_file_type_id = normalizeId(normalized.training_file_type_id);
          normalized.training_content_type_id = normalizeId(normalized.training_content_type_id);

          if (!normalized.training_file_type_id && normalized.content_type_id) {
            normalized.training_file_type_id = normalized.content_type_id;
          }

          // media File/Blob is appended manually to FormData; skip here to avoid media[name]/media[type]
          if (normalized.media instanceof File || normalized.media instanceof Blob) {
            delete normalized.media;
          }

          return omitUndefined(normalized);
        });

        return omitUndefined({
          ...contentItem,
          educations: normalizedEducations,
        });
      });
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: 'smooth'
      })
    },
    getTrainingTypes() {
      this.$store.dispatch(GET_CATEGORIES, {
        url: this.trainingCategoryUrl,
        filters: {
          'company_by_category': true,
        },
        acceptPromise: true,
      }).then(
        (response) => {
          if (response.status) {
            this.educationTypes = response.data;
          }
        }
      );
    },
  },
  mounted() {
    if (this.isEditMode) {
      this.fetchTraining(this.$route.params.id)
    }

    this.getTrainingTypes();
    this.getCurrency();

    this.getTrainingTypes();
    this.getCurrency();
    store.dispatch(_TRAINING_KIND_MODULE + '/' + GET_TRAINING_KINDS, {
      url: TRAINING_KIND_URL
    });
    store.dispatch(_HASHTAG_MODULE + '/' + GET_HASHTAGS, {
      url: HASHTAG_URL + '/?all=all'
    }).then((response) => {
      if (response?.data && !this.isEditMode) {
        this.company_id = response.data[0].company_id
      }
    });

  },
  beforeRouteLeave(to, from, next) {
    this.resetForm()
    next()
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.id) {
      this.fetchTraining(to.params.id)
    }
    next()
  },
  watch: {
    '$route.params.id'(newId) {
      if (newId) {
        this.fetchTraining(newId)
      }
    },
    formattedHashTag(value) {
      this.syncHashtagOptions(value);
    },
    'form.hashtags'(value) {
      if (value) {
        const names = value
          .map(id => this.hashtagOptions.find(item => item.id === id)?.name || String(id))
          .filter(Boolean);
        this.hashtagContent = this.isEditMode ? names.join(",") : names.join(", ");
      }
    },
  }
};
</script>

<style scoped>
input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.dragBox input[type="file"] {
  position: absolute;
  height: 100%;
  width: 100%;
  opacity: 0;
  top: 0;
  left: 0;
}

.dragBox {
  width: auto !important;
  padding: 10px;
  height: 100px;
  margin: 0 auto;
  position: relative;
  text-align: center;
  font-weight: bold;
  line-height: 95px;
  color: #999;
  border: 2px dashed #ccc;
  display: inline-block;
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
}

.uploadOuter strong {
  padding: 0 10px;
}

.uploadOuter {
  text-align: center;
  padding: initial !important;
}

.uk-alert {
  margin-bottom: 0;
}

.text-success {
  color: #0fa704 !important;
  font-size: 32px !important;
  transition: color 0.5s ease, font-size 0.5s ease;
}

#summaryImage {
  height: 200px;
}
</style>
